<template>
  <div>
    <h4>Nombre d'heures à payer</h4>
    <table class="table table-bordered table-compact paid-hours-table" style="width: auto">
      <thead>
        <th>Régulier</th>
        <th>Maladie</th>
        <th>Congés fériés</th>
        <th>Vacances</th>
        <th>Banque d'heure</th>
        <th>Total payé</th>
      </thead>
      <tbody>
        <tr>
          <td class="text-right">{{ formatDigit(totals.regularHours) }}</td>
          <td class="text-right">{{ formatDigit(totals.sicknessHours) }}</td>
          <td class="text-right">{{ formatDigit(totals.holidayHours) }}</td>
          <td class="text-right">{{ formatDigit(totals.vacationHours) }}</td>
          <td class="text-right">{{ formatDigit(totals.bankHours) }}</td>
          <td class="text-right bold">{{ formatDigit(totals.paidHours) }}</td>
        </tr>
        <tr>
          <td colspan="6" style="background-color: gray; height: 3px"></td>
        </tr>
        <tr>
          <td colspan="6" class="bold">Allocation initiale</td>
        </tr>
        <!-- <tr v-if="canAdjust">
          <td>&nbsp;</td>
          <td class="text-right" style="padding: 1px 3px"><input type="text" @click="$event.target.select()" @change="$emit('adjustmentChanged')" :value="formatDigit(allocation.sicknessHours + adjustments.sicknessHours)" class="input-text-fancy input-right input-100"></td>
          <td class="text-right" style="padding: 1px 3px"><input type="text" @click="$event.target.select()" @change="$emit('adjustmentChanged')" :value="formatDigit(allocation.holidayHours + adjustments.holidayHours)" class="input-text-fancy input-right input-100"></td>
          <td class="text-right" style="padding: 1px 3px"><input type="text" @click="$event.target.select()" @change="$emit('adjustmentChanged')" :value="formatDigit(allocation.vacationHours + adjustments.vacationHours)" class="input-text-fancy input-right input-100"></td>
          <td class="text-right" style="padding: 1px 3px"><input type="text" @click="$event.target.select()" @change="$emit('adjustmentChanged')" :value="formatDigit(-allocation.bankHours - adjustments.bankHours)" class="input-text-fancy input-right input-100"></td>
          <td>&nbsp;</td>
        </tr> -->
        <tr>
          <td>&nbsp;</td>
          <td class="text-right">{{ formatDigit(allocation.sicknessHours) }}</td>
          <td class="text-right">{{ formatDigit(allocation.holidayHours) }}</td>
          <td class="text-right">{{ formatDigit(allocation.vacationHours) }}</td>
          <td class="text-right">{{ formatDigit(-allocation.bankHours) }}</td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td colspan="6" class="bold">Plus ajustement</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td class="text-right">{{ formatDigit(adjustments.sicknessHours) }}</td>
          <td class="text-right">{{ formatDigit(adjustments.holidayHours) }}</td>
          <td class="text-right">{{ formatDigit(adjustments.vacationHours) }}</td>
          <td class="text-right">{{ formatDigit(-adjustments.bankHours) }}</td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td colspan="6" class="bold">Moins utilisé</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td class="text-right">{{ formatDigit(totals.sicknessHours) }}</td>
          <td class="text-right">{{ formatDigit(totals.holidayHours) }}</td>
          <td class="text-right">{{ formatDigit(totals.vacationHours) }}</td>
          <td class="text-right">{{ formatDigit(Math.max(totals.bankHours,0)) }}</td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td colspan="6" class="bold">Allocation restantes</td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td class="text-right" :class="{'cell-alert': sicknessHourDiff < 0}">{{ formatDigit(sicknessHourDiff) }}</td>
          <td class="text-right" :class="{'cell-alert': holidayHourDiff < 0}">{{ formatDigit(holidayHourDiff) }}</td>
          <td class="text-right" :class="{'cell-alert': vacationHoursDiff < 0}">{{ formatDigit(vacationHoursDiff) }}</td>
          <td class="text-right" :class="{'cell-alert': bankHourDiff < 0}">{{ formatDigit(bankHourDiff) }}</td>
          <td>&nbsp;</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: "timesheet-paid-hour-totals",
    props: {
      rows: {
        type: Array,
        default: () => []
      },
      allocation: {
        type: Object,
        default: () => ({
          sicknessHours: 0,
          holidayHours: 0,
          vacationHours: 0,
          bankHours: 0
        })
      },
      timesheet: {
        type: Object,
        default: () => ({})
      },
      editMode: {
        type: Boolean,
        default: true
      },
      canAdjust: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      hasAdjustments() {
        return this.sicknessHourDiff != 0 || this.holidayHourDiff != 0 || this.vacationHoursDiff != 0 || this.bankHourDiff != 0;
      },
      sicknessHourDiff(){
        return parseFloat(this.allocation.sicknessHours) + this.adjustments.sicknessHours - this.totals.sicknessHours;
      },
      holidayHourDiff(){
        return parseFloat(this.allocation.holidayHours) + this.adjustments.holidayHours - this.totals.holidayHours;
      },
      vacationHoursDiff(){
        return parseFloat(this.allocation.vacationHours) + this.adjustments.vacationHours - this.totals.vacationHours;
      },
      bankHourDiff(){
        return -parseFloat(this.allocation.bankHours) - this.adjustments.bankHours - Math.max(this.totals.bankHours,0);
      },
      totals() {
        let totals = {
          regularHours: 0,
          sicknessHours: 0,
          holidayHours : 0,
          vacationHours: 0,
          bankHours: 0,
          paidHours: 0
        }

        for (const row of this.rows) {
          if(row.timesheet_entry_type == "1") {
            for (const date in row.days) {
              if(row.days[date].timesheet_entry_value == "deleted" || row.days[date].timesheet_entry_value == null) continue;
              let isAdjustment = row.days[date].timesheet_entry_is_adjustment == '1';
              let value = parseFloat(row.days[date].timesheet_entry_value);
              switch(row.project_number){
                case "00-002G": // Maladie
                  totals.sicknessHours += isAdjustment ? 0 : Math.max(value, 0); // Utilisation de congée maladie
                  totals.paidHours += isAdjustment ? 0 : Math.max(value, 0);
                  break;
                case "00-004G": // Congé férié
                  totals.holidayHours += isAdjustment ? 0 : Math.max(value, 0); // Utilisation de congée ferié
                  totals.paidHours += isAdjustment ? 0 : Math.max(value, 0);
                  break;
                case "00-003G": // Vacances
                  totals.vacationHours += isAdjustment ? 0 : Math.max(value, 0); // Utilisation de vacances
                  totals.paidHours += isAdjustment ? 0 : Math.max(value, 0);
                  break;
                case "00-006G": // Banque
                  totals.bankHours += isAdjustment ? 0 : value; // Utilisation de la banque d'heure
                  totals.paidHours += isAdjustment ? 0 : value;
                  break;
                default: // Le reste
                  totals.regularHours += isAdjustment ? 0 : Math.max(value, 0); // Heures normales payés
                  totals.paidHours += isAdjustment ? 0 : Math.max(value, 0);
                  break;
              }
            }
          }
        }

        return totals;
      },
      adjustments() {
        let totals = {
          sicknessHours: 0,
          holidayHours : 0,
          vacationHours: 0,
          bankHours: 0
        }

        for (const row of this.rows) {
          if(row.timesheet_entry_type == "1") {
            for (const date in row.days) {
              if(row.days[date].timesheet_entry_value == "deleted" || row.days[date].timesheet_entry_value == null) continue;
              let isAdjustment = row.days[date].timesheet_entry_value < 0 || row.days[date].timesheet_entry_is_adjustment == '1';
              let value = parseFloat(row.days[date].timesheet_entry_value);
              switch(row.project_number){
                case "00-002G": // Maladie
                  totals.sicknessHours += isAdjustment ? -value : Math.min(value,0);
                  break;
                case "00-004G": // Congé férié
                  totals.holidayHours += isAdjustment ? -value : Math.min(value,0);
                  break;
                case "00-003G": // Vacances
                  totals.vacationHours += isAdjustment ? -value : Math.min(value,0);
                  break;
                case "00-006G": // Banque
                  totals.bankHours += isAdjustment ? value : Math.min(value,0);
                  break;
              }
            }
          }
        }

        return totals;
      }
    },
  }
</script>